export default __webpack_public_path__ + "static/media/smoothie-2.c326b573.svg";